import { SubscriptionStatus } from "@mindmemobile/mm-payment-modules";
import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { IFundraisersDonationsSubscriptionResponse, ISubscription } from "../interfaces";

export class SubscriptionModel {
  id: string;
  donorName: string;
  firstName?: string;
  lastName?: string;
  isAnonymous: boolean;
  donorEmail?: string;
  donorMobile?: string;
  nextDueDate: Date;
  totalPaid: number;
  paymentCount: number;
  status: keyof typeof SubscriptionStatus;
  fundraiserId: string;
  monthlyAmount: number;
  promoterId?: string;
  startDate: Date;
  // paymentMethod: {
  //   type: "card" | "ach" | "bank";
  //   brand?: "visa" | "mastercard" | "amex" | "discover";
  //   last4?: string;
  //   last6?: string;
  // };

  constructor(data?: Partial<SubscriptionModel>) {
    this.id = data?.id ?? "";
    this.startDate = data?.startDate ? new Date(data.startDate) : new Date();
    this.donorName = data?.donorName ?? "";
    this.firstName = data?.firstName ?? "";
    this.lastName = data?.lastName ?? "";
    this.isAnonymous = data?.isAnonymous ?? false;
    this.donorEmail = data?.donorEmail ?? "";
    this.donorMobile = data?.donorMobile ?? "";
    this.nextDueDate = data?.nextDueDate
      ? new Date(data.nextDueDate)
      : new Date();
    this.totalPaid = data?.totalPaid ?? 0;
    this.paymentCount = data?.paymentCount ?? 0;
    this.status = data?.status ?? SubscriptionStatus.Active;
    this.fundraiserId = data?.fundraiserId ?? "";
    this.promoterId = data?.promoterId ?? "";
    this.monthlyAmount = data?.monthlyAmount ?? 0;
    // this.paymentMethod = {
    //   type: data?.paymentMethod?.type ?? "card",
    //   brand: data?.paymentMethod?.brand ?? undefined,
    //   last4: data?.paymentMethod?.last4 ?? undefined,
    //   last6: data?.paymentMethod?.last6 ?? undefined,
    // };
  }


  getDisplayName() {
    if (this.isAnonymous) {
      return 'Anonymous Donor';
    }
    if (this.firstName && this.lastName) {
      return `${this.firstName} ${this.lastName}`;
    }
    return 'Anonymous Donor';
  };


  static deserializeAPIModel(data: IFundraisersDonationsSubscriptionResponse): SubscriptionModel {
    return new SubscriptionModel({
      id: data.subscriptionId,
      donorName: data.contact?.firstName && data.contact?.lastName
        ? `${data.contact.firstName} ${data.contact.lastName}`
        : data.contact?.firstName || data.contact?.lastName || " ",
      firstName: data.contact?.firstName,
      lastName: data.contact?.lastName, donorEmail: data.contact?.email,
      donorMobile: data.contact?.mobilePhone?.phoneNumber || data.contact?.homePhone?.phoneNumber ||
        data.contact?.workPhone?.phoneNumber,
      nextDueDate: data.nextDueOn ? new Date(data.nextDueOn) : undefined,
      /* The API field is TotalAmountPaid -> totalAmountPaid. This read `totalAmount`, which the
         response never carries, so Paid always showed $0.00 even with payments linked. */
      totalPaid: data.totalAmountPaid,
      paymentCount: data.totalPayments,
      status: data.status,
      monthlyAmount: data.amount,
      isAnonymous: data.anonymous,
      fundraiserId: data.fundRaiserId || "",
      /* Account time zone with a trailing "Z", same as the donation dates, so the "Z" comes off
         rather than letting the browser shift it again. Next Due above is left alone: the API never
         shifts that one, and the export says so in its header. */
      startDate: data.startDate
        ? UtilityMethods.removeZFromDateString(data.startDate)
        : new Date(),
    });
  }
}



